import './bml-case-banner.scss';
const TEMPLATE = `
<section class="case-banner container-fluid fade-up">
    <!-- Контейнер з колами та краплею -->
    <div class="case-circles-wrapper" data-animate-circles>
        <!-- Крапля в центрі -->
        <div class="case-drop-container">
            <img src="/images/case-drop.svg" alt="Drop" class="case-drop-image">
        </div>
        <!-- Кола -->
        <div class="case-circle case-circle-extra-large"></div>
        <div class="case-circle case-circle-large"></div>
        <div class="case-circle case-circle-medium"></div>
    </div>
    <div class="case-banner-description">
        <p class="case-description-header d-flex align-md-self-center" data-animate-child>Довіра до точності</p>
        <h1 data-animate-child>Точність у діагностиці. <br>Довіра у результатах</h1>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6">

            </div>
            <div class="col-md-6">
                <p data-animate-child>Кожен кейс — це доказ того, що діагностика BML працює на практиці. Ми
                    показуємо, як наші рішення допомагають лікарям у складних випадках і забезпечують пацієнтам
                    правильний шлях лікування.</p>
            </div>
        </div>
    </div>
</section>
`;

class BmlCaseBanner extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-case-banner', BmlCaseBanner);
